import { render, staticRenderFns } from "./GzhBtn.vue?vue&type=template&id=14f9669e&scoped=true"
import script from "./GzhBtn.vue?vue&type=script&lang=js"
export * from "./GzhBtn.vue?vue&type=script&lang=js"
import style0 from "./GzhBtn.vue?vue&type=style&index=0&id=14f9669e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f9669e",
  null
  
)

export default component.exports